"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchBusinessById = exports.fetchAllBusiness = exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const businessService_1 = require("./service/businessService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)('business/fetch', (fetchPayLoad, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const businessService = new businessService_1.BusinessService(Env_1.APIPATHENV);
        const response = yield businessService.fetchBusinessList(fetchPayLoad);
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('business/create', (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const businessService = new businessService_1.BusinessService(Env_1.APIPATHENV);
        const response = yield businessService.createBusiness(createPayload);
        return response;
    }
    catch (err) {
        throw new Error(err);
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('business/update', (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const businessService = new businessService_1.BusinessService(Env_1.APIPATHENV);
        const response = yield businessService.updateBusiness(createPayload);
        return response;
    }
    catch (err) {
        throw new Error(err.response.data.message);
    }
}));
exports.fetchAllBusiness = (0, toolkit_1.createAsyncThunk)('business/fetchAllBusiness', (fetchPayLoad, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const businessService = new businessService_1.BusinessService(Env_1.APIPATHENV);
        const response = yield businessService.fetchHostAllBusiness(fetchPayLoad);
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch");
    }
}));
exports.fetchBusinessById = (0, toolkit_1.createAsyncThunk)('business/fetchBusinessById', (thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const businessService = new businessService_1.BusinessService(Env_1.APIPATHENV);
        const response = yield businessService.fetchBusinessById();
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch");
    }
}));
